  <template>
  <Page :title="title">
    <div class="activeApply active edit">
      <van-cell-group class="">
        <van-cell title="客户名称" title-class="van-cell--required">
          <van-field
            placeholder="请输入客户名称"
            class="item2"
            v-model="traffic.customerName"
          />
        </van-cell>
        <van-cell title="客户电话">
          <van-field
            placeholder="请输入客户电话"
            class="item2"
            type="tel"
            v-model="traffic.phone"
          />
        </van-cell>
        <van-cell title="客户性别" title-class="van-cell--required">
          <van-field
            placeholder="请选择性别"
            class="item2"
            v-model="traffic.gender"
            readonly
            @click="() => (selectGender = true)"
          >
            <img
              :src="require('@/assets/img/uparrow.png')"
              class="uparrow"
              alt=""
              srcset=""
              slot="right-icon"
            />
          </van-field>
          <van-popup position="bottom" v-model="selectGender">
            <van-picker
              :columns="columnsGender"
              :default-index="0"
              show-toolbar
              @confirm="onChangeGender"
              @cancel="selectGender = false"
            />
          </van-popup>
        </van-cell>
        <van-cell title="客户类型" title-class="van-cell--required">
          <van-field
            placeholder="请选择客户类型"
            class="item2"
            v-model="traffic.customerType"
            readonly
            @click="() => (selectCustType = true)"
          >
            <img
              :src="require('@/assets/img/uparrow.png')"
              class="uparrow"
              alt=""
              srcset=""
              slot="right-icon"
            />
          </van-field>
          <van-popup position="bottom" v-model="selectCustType">
            <van-picker
              :columns="columnsCustType"
              show-toolbar
              :default-index="0"
              @confirm="onChangeCustType"
              @cancel="selectCustType = false"
            />
          </van-popup>
        </van-cell>
        <van-cell title="客户人数" title-class="van-cell--required">
          <van-field
            type="number"
            placeholder="请输客户人数"
            class="item2"
            v-model="traffic.visitCnt"
          />
        </van-cell>
        <van-cell title="到店时间" title-class="van-cell--required">
          <div class="flex">
            <div class="flex item1" @click="showDateTime1 = !showDateTime1">
              <p class="item1 date-time black" v-if="traffic.dateFrom">
                {{ traffic.dateFrom | getTime }}
              </p>
              <p class="item1 date-time" v-else>
                {{ "请选择" }}
              </p>
              <div slot="right-icon" class="triangle_border_down" />
            </div>
            <van-popup v-model="showDateTime1" position="bottom">
              <van-picker
                :columns="columnsTime"
                show-toolbar
                @confirm="getFirstDate"
                @cancel="showDateTime1 = !showDateTime1"
              />
            </van-popup>
            <div class="date-time-seperate"><span> 至 </span></div>
            <div class="flex item1" @click="showDateTime2 = !showDateTime2">
              <p class="item1 date-time black" v-if="traffic.dateTo">
                {{ traffic.dateTo | getTime }}
              </p>
              <p class="item1 date-time" v-else>
                {{ "请选择" }}
              </p>
              <div slot="right-icon" class="triangle_border_down" />
            </div>
            <van-popup v-model="showDateTime2" position="bottom">
              <van-picker
                :columns="columnsTime"
                show-toolbar
                @confirm="getLastDate"
                @cancel="showDateTime2 = !showDateTime2"
              />
            </van-popup>
          </div>
        </van-cell>
        <van-cell title="年龄区间" title-class="van-cell--required">
          <van-field
            placeholder="请选择年龄区间"
            class="item2"
            v-model="traffic.estimateAge"
            readonly
            @click="() => (selectAgeRange = true)"
          >
            <img
              :src="require('@/assets/img/uparrow.png')"
              class="uparrow"
              alt=""
              srcset=""
              slot="right-icon"
            />
          </van-field>
          <van-popup position="bottom" v-model="selectAgeRange">
            <van-picker
              :columns="columnsAgeRange"
              :default-index="0"
              show-toolbar
              @confirm="onChangeAgeRange"
              @cancel="selectAgeRange = false"
            />
          </van-popup>
        </van-cell>
        <van-cell title="所在城市" title-class="van-cell--required">
          <!-- <van-field placeholder="请输入讲师姓名" class="item2" v-model="traffic.U_TeacherName" @input="limitLength(100,'campaign','U_TeacherName')"/> -->
          <div class="basic-models-list-item">
            <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
            <div class="region flex" @click="downSelections(11)">
              <span>
                {{ traffic.provinceName || "请选择" }}
              </span>
              <img
                :src="require('@/assets/img/uparrow.png')"
                class="uparrow"
                alt
                srcset
              />
            </div>
            <div
              class="region flex"
              @click="traffic.province ? downSelections(12) : ''"
            >
              <span>{{ traffic.cityName || "请选择" }}</span>
              <img
                :src="require('@/assets/img/uparrow.png')"
                class="uparrow"
                alt
                srcset
              />
            </div>
            <!-- <div class="region" @click="downSelections(13)">
                {{district.name||'请选择-区'}}
                <img :src="require('@/assets/img/uparrow.png')" class="uparrow" alt srcset>
              </div> -->
          </div>
          <van-popup v-model="showDownSelection" position="bottom">
            <van-picker
              show-toolbar
              title
              :columns="downSelection"
              @cancel="onCancelCode"
              @confirm="onConfirmCode"
              value-key="name"
              class="van-picker-li"
            />
          </van-popup>
        </van-cell>
        <van-switch-cell
          title="是否试机"
          v-model="traffic.test"
          active-color="#ff4040"
          inactive-color="#000000"
          active-value="1"
          inactive-value="0"
          title-class="van-cell--required"
        />
        <div v-show="traffic.test === '1'">
          <van-cell-group title="试机产品">
            <van-checkbox-group v-model="choosenTried" class="products flex">
              <div
                v-for="item in products"
                :key="item.value"
                class="products-items"
              >
                <van-checkbox
                  :name="item.value"
                  :title="item.name"
                  checked-color="#ff4040"
                >
                  {{ item.name }}
                </van-checkbox>
              </div>
            </van-checkbox-group>
          </van-cell-group>
        </div>
        <van-switch-cell
          title="是否购买"
          v-model="traffic.buy"
          active-color="#ff4040"
          inactive-color="#000000"
          active-value="1"
          inactive-value="0"
          title-class="van-cell--required"
        />
        <div v-show="traffic.buy === '1'">
          <van-cell-group title="购机产品">
            <van-checkbox-group v-model="choosenBought" class="products flex">
              <div
                v-for="item in products"
                :key="item.value"
                class="products-items"
              >
                <van-checkbox
                  :name="item.value"
                  :title="item.name"
                  checked-color="#ff4040"
                >
                  {{ item.name }}
                </van-checkbox>
              </div>
            </van-checkbox-group>
          </van-cell-group>
        </div>
        <div v-show="traffic.buy !== '1'">
          <van-panel title="未成交原因" class="panel-margin">
            <van-field
              type="textarea"
              placeholder="请输入未成交原因"
              class="item2"
              v-model="traffic.reason"
            />
          </van-panel>
        </div>
        <van-panel title="备注" class="panel-margin">
          <van-field
            type="textarea"
            placeholder="请输入备注"
            class="item2"
            v-model="traffic.remark"
          />
        </van-panel>
      </van-cell-group>
      <!-- <van-cell-group class="group" title="系统信息">
        <van-cell title="销售顾问">
          <p class="item2">{{ salesaman }}</p>
        </van-cell>
        <van-cell title="所属门店">
          <p class="item2">{{ deptName }}</p>
        </van-cell>
        <van-cell title="创建时间">
          <p class="item2">
            {{ traffic.createdTime ? traffic.createdTime : createdTime }}
          </p>
        </van-cell>
      </van-cell-group> -->
      <div class="bottom-btn flex">
        <div class="item1 btn save" @click="cancelEdit">取消</div>
        <div class="item1 btn sub" @click="saveTraffic()">保存</div>
      </div>
    </div>
  </Page>
</template>
<script>
import moment from "moment";
import $config from "@/config/config";
import campKit from "@/common/campKit";
import imageCompression from "browser-image-compression";

export default {
  data() {
    return {
      title: "到店客流",
      id: "",
      traffic: {
        test: "1",
        buy: "1",
      }, // 客流信息
      columnsTime: [
        {
          values: [
            "09",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
          ],
        },
        {
          values: ["00", "10", "20", "30", "40", "50"],
        },
      ],
      columnsGender: ["", "男", "女"],
      selectGender: false, //显示选择性别开关
      selectCustType: false, //显示选择客户类型开关
      columnsCustType: ["", "邀约进店", "Walk In"],
      selectAgeRange: false, //显示选择年龄区间开关
      columnsAgeRange: [{ value: "", name: "" }],
      products: [],
      choosenTried: [],
      choosenBought: [],
      endDate: null, //活动结束时间
      firstDateTs: null, //开始时间戳
      endDateTs: null, //结束时间戳
      showDateTime1: false,
      showDateTime2: false,
      showDownSelection: false,
      downSelection: {},
      Locals: 0,
      salesaman: "",
      deptName: "",
      createdTime: "",
      loading: false,
    };
  },
  components: {},
  filters: {
    getTime: function (value) {
      if (!value) {
        return "";
      }
      return moment(value, "yyyy-MM-DD HH:mm:ss").format("HH:mm");
    },
  },
  watch: {},
  methods: {
    onChangeGender(picker, values) {
      this.traffic.gender = picker;
      this.selectGender = false;
    },
    onChangeCustType(picker, values) {
      this.traffic.customerType = picker;
      this.selectCustType = false;
    },
    onChangeAgeRange(picker, values) {
      this.traffic.estimateAge = picker;
      this.selectAgeRange = false;
    },
    handleOpend(e) {
      console.log("event: ", e);
      console.log("datetimepicker: ", this.$refs.dateTime1);
    },
    downSelections(val, index) {
      if (val == 11) {
        this.getLocals(1);
        this.Locals = 0;
      }
      if (val == 12) {
        this.getLocals("", this.traffic.province);
        this.Locals = 1;
      }
    },
    getLocals(ID, pid) {
      this.$api.getLocals({ pid: ID ? "" : pid }).then((Response) => {
        this.downSelection = Response.data;
        this.showDownSelection = true;
      });
    },
    onCancelCode() {
      this.showDownSelection = false;
    },
    onConfirmCode(val) {
      if (val) {
        if (this.Locals == 0) {
          this.traffic.provinceName = val.name;
          this.traffic.province = val.id;
          // 选择省份后清空城市
          this.traffic.cityName = null;
          this.traffic.city = null;
        } else if (this.Locals == 1) {
          this.traffic.cityName = val.name;
          this.traffic.city = val.id;
        }
        this.showDownSelection = false;
      }
    },
    cancelEdit() {
      this.$router.push({ path: "/customer-traffic" });
    },
    async saveTraffic() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$toast({
        duration: 0,
        mask: true,
        message: "到店信息正在保存中，请稍等...",
      });

      let data = {
        ...this.traffic,
        salesId: this.$wxuserUtil.getUserId(),
        testProducts: this.choosenTried.join(";"),
        buyProduct: this.choosenBought.join(";"),
      };
      if (this.traffic.trafficId) {
        try {
          let response = await this.$api.saveCustomerTraffic(data);
          this.loading = false;
          this.$toast.clear();
          if (response.success) {
            this.$title("到店信息保存成功");
          } else {
            this.$title(`到店信息保存失败,${response.msg}`);
          }
        } catch (error) {
          this.$toast.clear();
          this.$title(`到店信息保存失败`);
        }
        this.$router.push({
          path: "/view-customer-traffic",
          query: { id: this.traffic.trafficId },
        });
      } else {
        try {
          let response = await this.$api.addCustomerTraffic(data);
          this.loading = false;
          this.$toast.clear();
          if (response.success && response.data) {
            let result = response.data;
            this.traffic.trafficId = result.U_TrafficId;
            this.$router.push({
              path: "/view-customer-traffic",
              query: { id: result.U_TrafficId },
            });
            this.$title("到店信息保存成功");
          } else {
            this.$title(`到店信息保存失败,${response.msg}`);
          }
        } catch (error) {
          this.$toast.clear();
          this.$title(`到店信息保存失败`);
        }
      }
    },

    getFirstDate(e) {
      let firstDate = moment(
        new Date(this.createdTime.replaceAll("-", "/")).Format("yyyy-MM-dd ") +
          e.join(":"),
        "yyyy-MM-DD HH:mm"
      );
      if (
        this.traffic.dateTo &&
        firstDate.isAfter(moment(this.traffic.dateTo))
      ) {
        this.$title("开始时间不应晚于结束时间");
        return;
      }
      this.traffic.dateFrom = firstDate.format("yyyy-MM-DD HH:mm:ss");
      this.showDateTime1 = !this.showDateTime1;
    },
    getLastDate(e) {
      let lastDate = moment(
        new Date(this.createdTime.replaceAll("-", "/")).Format("yyyy-MM-dd ") +
          e.join(":"),
        "yyyy-MM-DD HH:mm"
      );

      if (
        this.traffic.dateFrom &&
        lastDate.isBefore(moment(this.traffic.dateFrom))
      ) {
        this.$title("结束时间不可早于开始时间");
        return;
      }
      this.traffic.dateTo = lastDate.format("yyyy-MM-DD HH:mm:ss");
      this.showDateTime2 = !this.showDateTime2;
    },

    limitLength(len, key1, key2) {
      let value = "";
      if (key2) {
        value = this.$data[key1][key2];
      } else {
        value = this.$data[key1];
      }
      if (value.length > len) {
        if (key2) {
          this.$data[key1][key2] = value.slice(0, len);
        } else {
          this.$data[key1] = value.slice(0, len);
        }
      }
    },
    getDetail(id) {
      let data = {
        salesId: this.$wxuserUtil.getUserId(),
        trafficId: id,
      };
      let response = this.$api.getCustomerTraffic(data);
      if (!response.data) {
        this.$title("该客流信息不存在，即将重定向到到店客流列表页面");
        setTimeout(() => {
          this.cancelEdit();
        }, 300);
      }
      let result = response.data;
      if ("0" === result.U_Status) {
        this.traffic = {
          trafficId: result.U_TrafficId,
          customerName: result.U_Customer,
          customerType: result.U_Type,
          gender: result.U_Gender,
          visitCnt: result.U_VisitCnt,
          dateFrom: result.U_ArrivalTime_From,
          dateTo: result.U_ArrivalTime_To,
          estimateAge: result.U_EstimateAge,
          province: result.U_Province,
          city: result.U_City,
          provinceName: result.provinceName,
          cityName: result.cityName,
          test: result.U_Test,
          testProducts: result.U_TestProduct,
          buy: result.U_Buy,
          buyProduct: result.U_BuyProduct,
          reason: result.U_Reason,
          remark: result.U_Remark,
          status: result.U_Status,
          phone: result.U_Phone,
          createdTime: result.U_CreatedTime,
        };
        this.choosenBought = this.traffic.buyProduct
          ? this.traffic.buyProduct.split(";")
          : [];
        this.choosenTried = this.traffic.testProducts
          ? this.traffic.testProducts.split(";")
          : [];
        this.createdTime = result.U_CreatedTime;
        return;
      }

      this.$title("订单已提交，不能修改");
      setTimeout(() => {
        this.cancelEdit();
      }, 300);
    },
    async queryDictionary() {
      try {
        let response = await this.$api.get("api/dict/queryDict", {
          tcodes: "EstimateAge,Test_BuyProduct",
        });
        console.log("dict: ", response);
        let ages = response.data["EstimateAge"];
        let products = response.data["Test_BuyProduct"];
        let mappedAges = ages.map((age) => {
          return age.value;
        });
        this.columnsAgeRange = ["", ...mappedAges.reverse()];

        this.products = products
          .map((p) => {
            return { value: p.value, name: p.name };
          })
          .reverse();
      } catch (error) {
        this.$title("发生错误!");
      }
    },
  },
  created() {
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id);
    } else {
      this.createdTime = new Date().Format("yyyy-MM-dd hh:mm:ss");
    }
    this.salesaman = this.$wxuserUtil.getUserName();
    this.deptName = this.$wxuserUtil.getDeptName();
    this.queryDictionary();
  },
  mounted() {
    this.$(":focus").blur();
    console.log("datetimepicker: ", this.$refs.dateTime1);
  },
};
</script>
<style scoped lang="less" rel="stylesheet/less">
// @import "../../../style/pageStyle/pageView-activeDetail.less";
.group {
  margin-top: 10px;
}
.mini-text {
  font-size: 11px;
}
.date-time {
  text-align: left;
}
.date-time-seperate {
  flex: 0.5;
  text-align: center;
}
.black {
  color: #323233;
}
.basic-models-list-item,
.basic-models-list-itemS {
  margin-left: 0.8rem;
  -ms-flex-item-align: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  // justify-content: space-between;
  position: relative;
  .van-field__control {
    font-size: 0.35rem;
  }
}

.region {
  width: 4rem;
  position: relative;
  -ms-flex-item-align: center;
  align-items: center;
  margin-left: 0.3rem;
}
.activeApply {
  padding-bottom: 55px;
}
.active .info .van-cell .van-cell__value {
  flex: 2;
}
.active.edit .van-cell .van-cell__title {
  font-weight: bold;
}
.van-cell.van-panel__header {
  padding: 0.2rem 0;
}
.van-cell.van-field {
  padding: 0;
}
.products {
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0.2rem 0.4rem 0;
}
.products-items {
  width: 33%;
  margin-bottom: 0.2rem;
}
.triangle_border_down {
  position: relative;
  top: 8px;
}

.panel-margin {
  margin: 0 0.4rem;
}
.bottom-btn {
  height: 46px;
  line-height: 46px;
  text-align: center;
  font-size: 15px;
  color: #fff;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
}
.bottom-btn .save {
  background-color: #222;
}
.bottom-btn .sub {
  background-color: #e10913;
}
.van-cell.van-panel__header.van-cell:not(:last-child)::after {
  border: none;
}
.item2.van-cell.van-field:not(:last-child)::after {
  border: none;
}

.uparrow {
  position: absolute;
  right: 0.2rem;
  top: 50%;
  width: 0.3rem;
  height: 0.3rem;
  margin-top: -0.15rem;
}

.van-hairline--top-bottom:after {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/client/childCompoents/editCustomerTraffic.vue